import { booleanEnv } from './string';

export function hideOnEnv() {
  return {
    personnelReserve: booleanEnv(process.env.REACT_APP_HIDE_PERSONNEL_RESERVE)
  };
}
